import api from "../../../services/api";

export const getManagerial = async (month: string) => {
  const response = await api.get('/api/shopify/managerial/managerial_dashboard', {
    params: { month },
  });
  return response.data;
};
